import { ArticleAttribute } from './ArticleAttribute';
import { ImageWithFallbackToShared } from './Image';
import { User } from './User';
export enum StorylineDilemmaOptionType {
  Text = 'TEXT',
  Attribute = 'ATTRIBUTE',
}

export type StorylineDilemmaOption = {
  id: string;
  type: StorylineDilemmaOptionType;
  title: string;
  description: string;
  order: number;
  image?: ImageWithFallbackToShared | null;
  attributeId?: string;
  attribute?: ArticleAttribute;
  userId?: string | null;
  dilemmaId?: string;
};

export type StorylineDilemma = {
  id: string;
  question: string;
  details: string;
  options: StorylineDilemmaOption[];
  universeId: string;
  order: number;
  customizedAt: Date | null;
  customizedByUserId: string | null;
  customizedBy: User | null;
};

export interface StorylineDilemmaChoiceInput {
  dilemmaId?: string;
  chosenOptionId?: string;
}
